// extracted by mini-css-extract-plugin
export default {"quotesToggleButton":"webpack-concepts-AutoDocExtraction-QuotesSection-QuotesSection-module__quotesToggleButton"};